import Popup from "../Popup/Popup";
import { TransformedEvent } from "../../Utils/ParsingUtil";
import { createSingleMeeting } from "../OutlookMeeting/OutlookMeeting";
import DOMPurify from "dompurify";

interface PopupProps {
  closePopup: () => void;
  selectedAppointment: TransformedEvent;
}

function AppointmentDetails({ closePopup, selectedAppointment }: PopupProps) {
  const handleButtonClick = () => {
    createSingleMeeting(selectedAppointment);
  };

  const popupTitle = (startDate: Date) => {
    const date = startDate.getDate().toString().padStart(2, "0");
    const month = startDate.toLocaleString("default", { month: "long" });
    const year = startDate.getFullYear();
    return `${date}. ${month} ${year}`;
  };

  const sanitizedHtml = (textToDisplay: string) => {
    return DOMPurify.sanitize(textToDisplay, {
      ALLOWED_TAGS: [
        "b",
        "br",
        "i",
        "u",
        "p",
        "strong",
        "em",
        "h1",
        "h2",
        "h3",
        "h3",
        "h4",
        "h5",
        "h6",
        "div",
        "hr",
        "ul",
        "ol",
        "li",
        "blockquote",
        "table",
        "thead",
        "caption",
        "tbody",
        "tr",
        "th",
        "td",
        "pre",
      ],
      ALLOWED_ATTR: [],
    });
  };
  return (
    <Popup
      close={closePopup}
      handleButtonClick={handleButtonClick}
      category={selectedAppointment.resource.topic}
      popupTitle={popupTitle(selectedAppointment.start)}
    >
      <div className="popup-content">
        <div
          className="title"
          dangerouslySetInnerHTML={{
            __html: sanitizedHtml(selectedAppointment.resource.longTitle),
          }}
        />
        {selectedAppointment.resource.description ? (
          <div
            className="appointment-description"
            dangerouslySetInnerHTML={{
              __html: sanitizedHtml(selectedAppointment.resource.description),
            }}
          />
        ) : (
          <div className="appointment-description">
            Terminbeschreibung nicht vorhanden
          </div>
        )}
      </div>
      {selectedAppointment.resource.link[0].split("|").length > 1 && (
        <div className="popup-content">
          <div className="links">
            <div className="links-desc">Mehr dazu unter:</div>
            <div className="links-container">
              {selectedAppointment.resource.link.map((link, index) => (
                <a
                  href={link.split("|")[0]}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  key={index}
                >
                  {link.split("|")[1]}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </Popup>
  );
}

export default AppointmentDetails;
